import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

export const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  ({ className, style, ...props }, ref) => (
    <input
      ref={ref}
      style={{
        height: 36,
        padding: '0 12px',
        borderRadius: 6,
        border: '1px solid #cbd5e1',
        background: '#fff',
        fontSize: 14,
        width: '100%',
        ...style,
      }}
      className={cn('input', className)}
      {...props}
    />
  ),
);
Input.displayName = 'Input';
